import { config } from './config';
import axios from "axios";


export const currenciesService = {
    getAll,
};


export function getAll(params) {

    return new Promise((resolve, reject) => {
      axios
        .get(`${config.apiUrl}/api/administration/available-account-currencies/`, {params})
        .then(response => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
}